function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  border-width: 4px;\n  border-style: solid;\n  border-left: 0;\n  border-color: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-shrink: 0;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: 400;\n  line-height: 1.43;\n  font-size: 14px;\n  color: #444;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  background-color: ", ";\n  max-width: 100%;\n  width: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React from "react";
import styled from "styled-components";
import Grid from "styled-components-grid";
import { Padding, Margin } from "styled-components-spacing";
import colors from "@nib-components/colors";
import Heading from "@nib-components/heading";
import { TickInCircleSystemIcon, InfoSystemIcon, WarningSystemIcon, CrossInCircleSystemIcon } from "@nib/icons";

var pickColor = function pickColor(alertType) {
  switch (alertType) {
    case "info":
    default:
      return colors.malcom;

    case "error":
      return colors.julia;

    case "success":
      return colors.william;

    case "warning":
      return colors.kate;
  }
};

var renderIcon = function renderIcon(type) {
  switch (type) {
    case "info":
    default:
      return /*#__PURE__*/React.createElement(InfoSystemIcon, {
        fill: "white"
      });

    case "error":
      return /*#__PURE__*/React.createElement(CrossInCircleSystemIcon, {
        fill: "white"
      });

    case "success":
      return /*#__PURE__*/React.createElement(TickInCircleSystemIcon, {
        fill: "white"
      });

    case "warning":
      return /*#__PURE__*/React.createElement(WarningSystemIcon, {
        fill: "white"
      });
  }
};

var StyledAlert = styled.div(_templateObject(), colors.white, function (props) {
  return props.fullWidth ? "100%" : "auto";
});
var SubHeading = styled.div(_templateObject2(), function (_ref) {
  var theme = _ref.theme;
  return theme.fonts && theme.fonts.copy || "sans-serif";
});
var FlexGridUnit = styled(Grid.Unit)(_templateObject3());
export var IconWrapper = styled.div(_templateObject4(), function (props) {
  return pickColor(props.background);
});
export var StyledTextGridUnit = styled(Grid.Unit)(_templateObject5(), function (props) {
  return pickColor(props.type);
});

var Alert = function Alert(props) {
  var title = props.title,
      children = props.children,
      type = props.type,
      fullWidth = props.fullWidth,
      otherProps = _objectWithoutProperties(props, ["title", "children", "type", "fullWidth"]);

  return /*#__PURE__*/React.createElement(StyledAlert, _extends({
    type: type,
    fullWidth: fullWidth
  }, otherProps), /*#__PURE__*/React.createElement(Grid, {
    wrap: false
  }, /*#__PURE__*/React.createElement(FlexGridUnit, {
    size: "min"
  }, /*#__PURE__*/React.createElement(IconWrapper, {
    background: type
  }, /*#__PURE__*/React.createElement(Padding, {
    all: 3
  }, renderIcon(type)))), /*#__PURE__*/React.createElement(StyledTextGridUnit, {
    type: type,
    size: "max"
  }, /*#__PURE__*/React.createElement(Padding, {
    all: 3
  }, title && /*#__PURE__*/React.createElement(Margin, {
    bottom: children ? 3 : 0
  }, /*#__PURE__*/React.createElement(Heading, {
    size: 4
  }, title)), children && /*#__PURE__*/React.createElement(SubHeading, null, children)))));
};

Alert.displayName = "Alert";
export default Alert;